(function () {
    'use strict';

    angular
        .module('admin')
        .controller('AdmDepartmentListController', AdmDepartmentListController);

    AdmDepartmentListController.$inject = ['AdmService','$uibModal'];

    function AdmDepartmentListController(AdmService, $uibModal) {
        var vm = this;
        vm.activate = activate;
        vm.getByFilter      = getByFilter;
        vm.search           = '';
        vm.queryFlag        = false;
        vm.deleteDepartment = deleteDepartment;
        vm.openEditModal    = openEditModal;

        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.page         = 1;

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getByFilter(false);
        }

        function getByFilter()
        {
            vm.queryFlag        = false;
            vm.query            = {};
            vm.query['page']    = vm.page;
            if(typeof vm.search !== 'undefined' && vm.query !== '') {
                vm.query['search']  = vm.search;
            }
            AdmService.getDepartments(vm.query).then(function(response){                
                vm.queryFlag        = true;
                vm.departments      = response.data.data;
                vm.totalItems       = response.data.total;
                vm.itemsPerPage     = response.data.per_page;
                vm.setPage(response.data.current_page);
            }).catch(function(err) {

            });
        }

        function deleteDepartment(department){
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancel'
                })
                .set('title', 'Do you really want to delete this department: ' + department.name+'?')
                .set('onok', function (){

                    AdmService.deleteDepartment(department.id).then(function () {
                        vm.departments.splice(vm.departments.indexOf(department), 1);
                        alertify.notify('Department is successfully deleted', 'success', 3);
                    });
                })
                .show();
        }

        function openEditModal(department) {

            $uibModal.open({
                templateUrl: 'templates/adm/department/edit/template.modal.html',
                controller: 'AdmDepartmentEditController',
                controllerAs:'vm',
                resolve:
                    {
                        department      : function () {
                            return department;
                        }
                    }
            });
        }

        function activate() {
            vm.getByFilter();
        }
        vm.activate();
    }

})();